import request from '@/utils/jqReqyest'


//卖货人排行
export function GetGiverSummaryList(query,data) {
  return request({
    url: '/admin/GetGiverSummaryList.action',
    method: 'post',
    headers: {"Content-Type": "application/json",token:query.token},
    data:{date:data},
  })
}


// WEBPACK FOOTER //
// ./src/api/jqApi.js